// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Link_anchor__JMK8T"};